import {combineReducers} from "redux";

import appsetup from "../features/admin/customizations/appsetup/Slice";
import sociallink from "../features/admin/customizations/social_link/Slice";
import common from "../features/admin/common/Slice";

const customizations = combineReducers({
    appsetup,
    sociallink,
    common
});

export default customizations;